import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=2726a71e&scoped=true"
import script from "./myNews.vue?vue&type=script&lang=js"
export * from "./myNews.vue?vue&type=script&lang=js"
import style0 from "./myNews.vue?vue&type=style&index=0&id=2726a71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726a71e",
  null
  
)

export default component.exports